import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CompetingBiddersClient,
    CustomReportCompetingBiddersView,
    GetCompetingBiddersColumnChartValuesResultType,
    GetCompetingBiddersLineChartValuesResultType,
    GetCompetingBiddersMetricsValuesResultType,
    GetCompetingBiddersValuesParameters,
    GetCompetingBiddersValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CompetingBiddersService extends CustomReportServiceBase<
    CompetingBiddersClient,
    CustomReportCompetingBiddersView
> {
    constructor(protected override client: CompetingBiddersClient) {
        super(client);
    }

    async getValues(parameters: GetCompetingBiddersValuesParameters): Promise<GetCompetingBiddersValuesResultType[]> {
        return await lastValueFrom(this.client.competingBiddersGetCompetingBiddersValues(parameters));
    }

    async getBoxesValues(parameters: GetCompetingBiddersValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.competingBiddersGetCompetingBiddersBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetCompetingBiddersValuesParameters
    ): Promise<GetCompetingBiddersColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.competingBiddersGetCompetingBiddersColumnChartValues(parameters));
    }

    async getMetricsValues(
        parameters: GetCompetingBiddersValuesParameters
    ): Promise<GetCompetingBiddersMetricsValuesResultType> {
        return await lastValueFrom(this.client.competingBiddersGetCompetingBiddersMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetCompetingBiddersValuesParameters
    ): Promise<GetCompetingBiddersLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.competingBiddersGetCompetingBiddersLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportCompetingBiddersView): Promise<CustomReportCompetingBiddersView> {
        if (body.isPublic) return await lastValueFrom(this.client.competingBiddersSaveCatalogReport(body));
        else return await lastValueFrom(this.client.competingBiddersSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportCompetingBiddersView> {
        return await lastValueFrom(this.client.competingBiddersGetCustomReport(id));
    }

    override async shareReport(body: CustomReportCompetingBiddersView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.competingBiddersCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportCompetingBiddersView> {
        return await lastValueFrom(this.client.competingBiddersGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.competingBiddersResultAvailableColumns(organizationIds));
    }
}
